import React, { useEffect, useState, forwardRef, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { InputField } from "../../../../Components/formElements/InputField";
import { getTodayDate } from "../../../../common/Validations";
import toast from "react-hot-toast";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import { getEquipmentRentFormList } from "../../../../redux/feature/customer_app/customerSlice";
// import CustomerConstants from "../../../../common/CustomerConstants";
// import { useNavigate } from "react-router-dom";
import EwayBillModal from "./EwayBillModal";
import ERFPaymentSection from "./ERFPaymentSection";
import ERFTravelSection from "./ERFTravelSection";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import { Form } from "react-bootstrap";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

// ── Utility: ISO UTC string → IST display ──────────────────────────────────
const formatIST = (isoString) => {
  if (!isoString) return { date: "--", time: "" };
  const d = new Date(isoString);
  const date = d.toLocaleDateString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const time = d.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  return { date, time };
};

const DispatchModal = forwardRef((props, ref) => {
  const dispatch = useDispatch();

  // const navigate = useNavigate();
  const { show, onHide, erfData, onSuccess } = props;

  const [rentItems, setrentItems] = useState([]);

  const [saleItems, setSaleItems] = useState([]);
  const [accessoryItems, setAccessoryItems] = useState([]);
  const [serviceItems, setServiceItems] = useState([]);

  //eslint-disable-next-line
  const [loading, setLoading] = useState(false);

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [hasUnsavedTravel, setHasUnsavedTravel] = useState(false);

  const onSuccessUploadDocumentType = (data) => {
    setDispatchHeader((prev) => ({
      ...prev,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };

  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [showEwayForm, setShowEwayForm] = useState(false);

  const handleOpenEwayForm = () => {
    setShowEwayForm(true);
  };

  const handleCloseEwayForm = () => {
    setShowEwayForm(false);
  };

  //  Header Level Dispatch Details
  const [dispatchHeader, setDispatchHeader] = useState({
    truckNo: "",
    driverName: "",
    contactNumber: "",
    dispatchAddress: "",
    addressPincode: "",
    dispatchTime: getCurrentTime(),
    dispatchDate: getTodayDate(""),
    dispatchVehicle: "",
    erfDispatchRemark: "",
    erfDispatchDateAndTime: "",
    ewayBillDate: "",
    ewayBillNo: "",
    dispatchDocumentsUpload: "",
  });

  useEffect(() => {
    // 1. Process rentItems — always clear if no items to prevent stale data leakage
    if (erfData?.rentItems?.length > 0) {
      const mappedRent = erfData.rentItems.map((item, index) => ({
        ...item,
        local_id: item.local_id || item._id || `rent-${index}`,
        dispatchQty: "",
        disPatchedDate: getTodayDate(""),
        disPatchedTime: getCurrentTime(),
      }));
      setrentItems(mappedRent);
    } else {
      setrentItems([]);
    }

    // 2. Process saleItems — always clear if no items to prevent stale data leakage
    if (erfData?.saleItems?.length > 0) {
      const mappedSale = erfData.saleItems.map((item, index) => ({
        ...item,
        local_id: item.local_id || item._id || `sale-${index}`,
        dispatchQty: "",
        disPatchedDate: getTodayDate(""),
        disPatchedTime: getCurrentTime(),
      }));
      setSaleItems(mappedSale);
    } else {
      setSaleItems([]);
    }

    if (erfData?.accessoryItems?.length > 0) {
      const mappedAccessories = erfData.accessoryItems.map((item, index) => ({
        ...item,
        local_id: item.local_id || item._id || `acc-${index}`,
        disPatchedDate: getTodayDate(""),
        disPatchedTime: getCurrentTime(),
      }));
      setAccessoryItems(mappedAccessories);
    } else {
      setAccessoryItems([]);
    }

    if (erfData?.serviceItems?.length > 0) {
      const mappedService = erfData.serviceItems.map((item, index) => ({
        ...item,
        local_id: item.local_id || item._id || `service-${index}`,
        disPatchedDate: getTodayDate(""),
        disPatchedTime: getCurrentTime(),
      }));
      setServiceItems(mappedService);
    } else {
      setServiceItems([]);
    }
  }, [erfData]);

  // Sync travelHistory from erfData when modal opens
  useEffect(() => {
    if (erfData && show) {
      setDispatchHeader({
        truckNo: "",
        driverName: "",
        contactNumber: "",
        dispatchAddress: erfData?.deliveryAddress || "",
        addressPincode: erfData?.deliveryPinCode || "",
        dispatchTime: getCurrentTime(),
        dispatchDate: getTodayDate(""),
        dispatchVehicle: "",
        erfDispatchRemark: "",
        erfDispatchDateAndTime: "",
        ewayBillDate: "",
        ewayBillNo: "",
        dispatchDocumentsUpload: "",
      });
      setIsDispatched(erfData?.erfStatusCode === "DPD");
    }
  }, [erfData, show]);

  useEffect(() => {
    setTravelHistory(erfData?.travelHistory ?? []);
  }, [erfData]);

  // Reset ALL state when modal closes to prevent data leakage between records
  useEffect(() => {
    if (!show) {
      setrentItems([]);
      setSaleItems([]);
      setAccessoryItems([]);
      setServiceItems([]);
      setTravelHistory([]);
      setHasUnsavedTravel(false);
      setIsDispatched(false);
      setFormInputs({});
      setEwayData({
        transportId: "",
        transportMode: "Road",
        transporterName: "",
        transportDistance: "",
        transportDocNo: "",
        transportDocDate: "",
        vehicleNo: "",
        vehicleType: "Regular",
      });
      setDispatchHeader({
        truckNo: "",
        driverName: "",
        contactNumber: "",
        dispatchAddress: "",
        addressPincode: "",
        dispatchTime: getCurrentTime(),
        dispatchDate: getTodayDate(""),
        dispatchVehicle: "",
        erfDispatchRemark: "",
        erfDispatchDateAndTime: "",
        ewayBillDate: "",
        ewayBillNo: "",
        dispatchDocumentsUpload: "",
      });
      setShowJobStatusModal(false);
      setJobStatusRemarks("");
    }
  }, [show]);

  //  Handle Header Input Change
  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setDispatchHeader((prev) => ({ ...prev, [name]: value }));
  };
  let userData = useSelector((state) => state?.user); // User Details from Store

  // --- 1. ROLE IDENTIFICATION ---
  const isSalesPerson = useMemo(() => {
    return (
      userData?.data?.roles?.some((r) => r.roleId === "SALES-OFFICER") || false
    );
  }, [userData]);

  const isStorePerson = useMemo(() => {
    return userData?.data?.roles?.some((r) => r.roleId === "STORE") || false;
  }, [userData]);

  const isServiceExecutive = useMemo(() => {
    return (
      userData?.data?.roles?.some((r) => r.roleId === "SERVICE-EXECUTIVE") ||
      false
    );
  }, [userData]);

  const isDispatchManager = useMemo(() => {
    return userData?.data?.roles?.some((r) => r.roleId === "DISPATCH") || false;
  }, [userData]);

  // Handle row input change
  const handleInputChange = (localId, event, type = "rent") => {
    const { name, value } = event.target;
    const updater = (prev) =>
      prev.map((item) =>
        item.local_id === localId ? { ...item, [name]: value } : item,
      );

    if (type === "sale") {
      setSaleItems(updater);
    } else {
      setrentItems(updater);
    }
  };

  const handleInputChangeService = (localId, event) => {
    const { name, value } = event.target;
    setServiceItems((prev) =>
      prev.map((item) =>
        item.local_id === localId ? { ...item, [name]: value } : item,
      ),
    );
  };

  const [isCardVisible, setCardVisible] = useState(true);
  const [isDispatchVisible, setIsDispatchVisible] = useState(true);
  const [isDispatchVisible2, setIsDispatchVisible2] = useState(true);
  const [showImage, setShowImage] = useState(false);

  // ── Travel Section ──────────────────────────────────────────────────────────
  const [travelHistory, setTravelHistory] = useState([]);

  const currentUserName =
    userData?.data?.firstName ||
    userData?.data?.name ||
    userData?.data?.userId ||
    "";

  const [showJobStatusModal, setShowJobStatusModal] = useState(false);
  const [jobStatusTarget, setJobStatusTarget] = useState(""); // "Done" or "Not Done"
  const [jobStatusRemarks, setJobStatusRemarks] = useState("");
  const [isDispatched, setIsDispatched] = useState(false);

  const [showFailureModal, setShowFailureModal] = useState(false);
  const [errorFields, setErrorFields] = useState([]);
  const failureModalData = { title: "Validation Error" };

  const handleTravelSave = async (newRows) => {
    const allRows = [...travelHistory, ...newRows];
    try {
      const obj = {
        documentNumber: erfData.documentNumber,
        equipmentRentNr: erfData.documentNumber,
        travelHistory: allRows,
      };
      // console.log("payload for Save", obj);
      await ItemService.updateEquipmentRentForm(obj);
      toast.success(
        `${newRows.length} travel entr${newRows.length > 1 ? "ies" : "y"} saved`,
      );
      setTravelHistory(allRows); // update local state → child clears newRows
    } catch (err) {
      toast.error("Failed to save travel entries");
      throw err; // re-throw → child keeps newRows on failure
    }
  };

  const handleTravelConfirmRow = async (rowId, stage, { remarks }) => {
    const rowIndex = travelHistory.findIndex((r) => r._id === rowId);
    const row = travelHistory[rowIndex];
    if (!row) return;

    const stageKeyMap = {
      se: "seConfirmation",
      dispatch: "dispatchConfirmation",
      finance: "financeConfirmation",
    };
    const confirmationKey = stageKeyMap[stage];
    if (!confirmationKey) return;

    const updatedRows = travelHistory.map((r, i) =>
      i === rowIndex
        ? {
            ...r,
            [confirmationKey]: {
              confirmed: true,
              remarks,
              confirmedBy: currentUserName,
              confirmedAt: new Date().toISOString(),
            },
          }
        : r,
    );

    try {
      await ItemService.updateEquipmentRentForm({
        documentNumber: erfData.documentNumber,
        equipmentRentNr: erfData.documentNumber,
        travelHistory: updatedRows,
      });
      const msgs = {
        se: "Confirmed by SE",
        dispatch: "Approved by dispatch",
        finance: "Marked as paid",
      };
      toast.success(msgs[stage] ?? "Confirmation saved");
      setTravelHistory(updatedRows);
    } catch {
      toast.error("Failed to save confirmation");
    }
  };

  const handleMarkJobStatus = async (status, remarks = "") => {
    if (!remarks.trim()) {
      setErrorFields(["Remarks are mandatory"]);
      setShowFailureModal(true);
      return;
    }

    const existingHistory = erfData?.assignedServiceExecutives || [];
    const latestIdx = existingHistory.length - 1;

    const updatedHistory = existingHistory.map((se, idx) =>
      idx === latestIdx
        ? {
            ...se,
            jobStatus: status,
            jobStatusRemarks: remarks,
            jobStatusUpdatedAt: new Date().toISOString(),
            jobStatusUpdatedBy: userData?.data?.userId,
          }
        : se,
    );

    try {
      await ItemService.updateEquipmentRentForm({
        documentNumber: erfData.documentNumber,
        equipmentRentNr: erfData.documentNumber,
        assignedServiceExecutives: updatedHistory,
        jobDoneStatus: status,
        jobDoneRemarks: remarks,
        jobDoneUpdatedAt: new Date().toISOString(),
        jobDoneUpdatedBy: userData?.data?.userId,
      });
      toast.success(
        status === "Done"
          ? "Job marked as completed"
          : "Job marked as not done",
      );
      setShowJobStatusModal(false); // ← close confirmation modal first
      setJobStatusRemarks("");
      onHide();
      onSuccess?.();
    } catch {
      toast.error("Failed to update job status");
    }
  };

  // const [showEwayForm, setShowEwayForm] = useState(false);
  const [ewayData, setEwayData] = useState({
    transportId: "",
    transportMode: "Road",
    transporterName: "",
    transportDistance: "",
    transportDocNo: "",
    transportDocDate: "",
    vehicleNo: "",
    vehicleType: "Regular",
  });

  const [
    isServiceExecutiveHistoryVisible,
    setIsServiceExecutiveHistoryVisible,
  ] = useState(true);

  const [isAccessoriesVisible, setIsAccessoriesVisible] = useState(true);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility1 = () => {
    setIsDispatchVisible(!isDispatchVisible);
  };

  const toggleCardVisibility2 = () => {
    setIsDispatchVisible2(!isDispatchVisible2);
  };

  const toggleCardVisibility3 = () => {
    setIsServiceExecutiveHistoryVisible(!isServiceExecutiveHistoryVisible);
  };

  const toggleCardVisibility5 = () => {
    setIsAccessoriesVisible(!isAccessoriesVisible);
  };

  function getCurrentTime() {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  }

  const convertToNumbers = (obj) => {
    const converted = { ...obj };
    const numericFields = [
      "orderedQuantity",
      "sellingPrice",
      "rentPerDay",
      "rent7Days",
      "rent15Days",
      "rent30Days",
      "days",
      "netValue",
      "grossValue",
      "taxPercentage",
      "taxAmount",
      "actualSecurityAmt",
      "securityAmt",
      "masterMRP",
      "masterSellingPrice",
      "masterUnitPrice",
      "refundAmt",
      "refundDays",
    ];
    numericFields.forEach((field) => {
      if (converted[field] !== undefined && converted[field] !== "") {
        converted[field] = parseFloat(converted[field]) || 0;
      }
    });
    return converted;
  };

  //eslint-disable-next-line
  const [formInputs, setFormInputs] = useState({});

  //eslint-disable-next-line
  const fetchData = async (page = 1, size = 10, search = "") => {
    setLoading(true);
    try {
      const payload = {
        queryName: "DPDERF",
        page,
        per_page: size,
        searchTerm: search,
        timeZone: "Asia/Calcutta",
        rowFilter: {},
      };

      let statusFilter = null;

      if (isSalesPerson) {
        statusFilter = ["In progress", "Approved"];
      } else if (isStorePerson) {
        statusFilter = ["Approved", "Dispatched"];
      }

      if (statusFilter) {
        payload.rowFilter = {
          $and: [{ status: { $in: statusFilter } }],
        };
      }

      await dispatch(getEquipmentRentFormList(payload));
    } catch (error) {
      console.error("Error fetching list", error);
      toast.error("Error loading records");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    // Validate dispatch header fields
    const errors = [];
    if (!dispatchHeader.truckNo.trim())
      errors.push("Truck/Vehicle No is required");
    if (!dispatchHeader.driverName.trim())
      errors.push("Driver Name is required");
    if (!dispatchHeader.contactNumber.trim())
      errors.push("Contact Number is required");
    if (!dispatchHeader.dispatchAddress.trim())
      errors.push("Dispatch Address is required");
    if (!dispatchHeader.addressPincode.trim())
      errors.push("Address Pincode is required");
    if (!dispatchHeader.dispatchVehicle.trim())
      errors.push("Dispatch Vehicle is required");
    if (!dispatchHeader.dispatchDocumentsUpload.trim())
      errors.push("Dispatch/Service Documents are required");

    if (errors.length > 0) {
      setErrorFields(errors);
      setShowFailureModal(true);
      return;
    }

    try {
      const processedRentItems = rentItems.map((item) => ({
        ...convertToNumbers(item),
        erfStatus: "Dispatched",
        erfStatusCode: "DPD",
        erfDispatched: true,
        erfDispatchRemark: item.erfDispatchRemark,
        disPatchedDate: dispatchHeader.dispatchDate,
        disPatchedTime: dispatchHeader.dispatchTime,
      }));

      const processedSaleItems = saleItems.map((item) =>
        convertToNumbers(item),
      );

      const processedServiceItems = serviceItems.map((item) => ({
        ...convertToNumbers(item),
        erfStatus: "Dispatched",
        erfStatusCode: "DPD",
        erfDispatched: true,
        disPatchedDate: item.disPatchedDate || dispatchHeader.dispatchDate,
        disPatchedTime: item.disPatchedTime || dispatchHeader.dispatchTime,
      }));

      const processedAccessoryItems = accessoryItems.map((item) => ({
        ...item,
        disPatchedDate: item.disPatchedDate || dispatchHeader.dispatchDate,
        disPatchedTime: item.disPatchedTime || dispatchHeader.dispatchTime,
        erfDispatched: true,
      }));

      const dispatchTimestamp = new Date().toISOString();

      const payloadData = {
        ...formInputs,

        // Header Level Status
        erfStatus: "Dispatched",
        erfStatusCode: "DPD",
        jobDoneStatus: "Pending",
        disPatchedDate: dispatchHeader.dispatchDate,
        disPatchedTime: dispatchHeader.dispatchTime,

        erfDispatchDateAndTime: dispatchTimestamp,

        //  Header Level Dispatch Details - Array of Object
        dispatchDetails: [
          {
            dispatchErfStatus: "Dispatched",
            erfStatusCode: "DPD",
            truckNo: dispatchHeader.truckNo,
            driverName: dispatchHeader.driverName,
            contactNumber: dispatchHeader.contactNumber,
            dispatchAddress: dispatchHeader.dispatchAddress,
            addressPincode: dispatchHeader.addressPincode,
            dispatchVehicle: dispatchHeader.dispatchVehicle,
            dispatchDate: dispatchHeader.dispatchDate,
            dispatchTime: dispatchHeader.dispatchTime,
            erfDispatchRemark: dispatchHeader.erfDispatchRemark,
            erfDispatchDateAndTime: dispatchTimestamp,
            dispatchDocumentsUpload:
              dispatchHeader.dispatchDocumentsUpload || "",
            ewayBillUpload: dispatchHeader.ewayBillUpload || "",
            ewayBillDate: dispatchHeader.ewayBillDate || "",
            ewayBillNo: dispatchHeader.ewayBillNo || "",
          },
        ],

        dispatchDocumentsUpload: dispatchHeader.dispatchDocumentsUpload || "",
        ewayBillUpload: dispatchHeader.ewayBillUpload || "",
        ewayBillDate: dispatchHeader.ewayBillDate || "",
        ewayBillNo: dispatchHeader.ewayBillNo || "",

        // Basic Required Keys
        documentNumber: erfData.documentNumber,
        erfTypeCode: erfData.erfTypeCode,
        equipmentRentNr: erfData?.documentNumber,
        erfTypeDescription: erfData.erfTypeDescription,
        seTravelDetails: [{ ...ewayData }],
        rentItems: processedRentItems,
        saleItems: processedSaleItems,
        accessoryItems: processedAccessoryItems,
        serviceItems: processedServiceItems,
      };
      // console.log("Payload for Update:", payloadData);

      delete payloadData.data;
      delete payloadData._id;
      // console.log("payload", payloadData)

      await ItemService.updateEquipmentRentForm(payloadData);
      toast.success("ERF Dispatched Successfully");
      setIsDispatched(true);
      onSuccess?.(); //  notify parent to re-fetch
    } catch (err) {
      toast.error("Failed to update ERF");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // DataTable Columns
  const columns = [
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.materialDescription}</p>
          <p className="m-0 text-muted">{row.materialCode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.barcode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row.orderedQuantity}</p>
          <p className="m-0 text-muted">{row.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "120px",
    },
    { name: "Rent / Day", selector: (row) => row.rentPerDay, width: "120px" },
    { name: "Days", selector: (row) => row.days, width: "100px" },
    { name: "Net Value", selector: (row) => row.netValue, width: "120px" },
    { name: "Tax %", selector: (row) => row.taxPercentage, width: "100px" },
    { name: "Gross Value", selector: (row) => row.grossValue, width: "130px" },
    { name: "From Date", selector: (row) => row.fromDate, width: "130px" },
    { name: "To Date", selector: (row) => row.toDate, width: "130px" },
    { name: "Storage", selector: (row) => row.storageLocn, width: "150px" },
    {
      name: "Status",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              row.status === "In Progress" ? "#ffc107" : "#28a745",
            color: "black",
            padding: "6px 10px",
            borderRadius: "10px",
          }}
        >
          {row.status}
        </span>
      ),
      width: "150px",
    },
    // {
    //   name: "Dispatch Remarks",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox"
    //       name="erfDispatchRemark"
    //       value={row.erfDispatchRemark}
    //       onChange={(e) => handleInputChange(row.local_id, e)}
    //     />
    //   ),
    //   width: "150px",
    // },
    {
      name: "Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate}
          onChange={(e) => handleInputChange(row.local_id, e)}
        />
      ),
      width: "160px",
    },
    {
      name: "Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime}
          onChange={(e) => handleInputChange(row.local_id, e)}
        />
      ),
      width: "160px",
    },
  ];

  const saleColumns = [
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.materialDescription}</p>
          <p className="m-0 text-muted">{row.materialCode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.barcode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row.orderedQuantity}</p>
          <p className="m-0 text-muted">{row.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "120px",
    },
    { name: "Net Value", selector: (row) => row.netValue, width: "120px" },
    { name: "Tax %", selector: (row) => row.taxPercentage, width: "100px" },
    { name: "Tax Amount", selector: (row) => row.taxAmount, width: "100px" },
    { name: "Gross Value", selector: (row) => row.grossValue, width: "130px" },
    { name: "Storage", selector: (row) => row.storageLocn, width: "150px" },
    {
      name: "Status",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              row.status === "In Progress" ? "#ffc107" : "#28a745",
            color: "black",
            padding: "6px 10px",
            borderRadius: "10px",
          }}
        >
          {row.status}
        </span>
      ),
      width: "150px",
    },
    // {
    //   name: "Dispatch Remarks",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox"
    //       name="erfDispatchRemark"
    //       value={row.erfDispatchRemark}
    //       onChange={(e) => handleInputChange(row.local_id, e, "sale")}
    //     />
    //   ),
    //   width: "150px",
    // },
    {
      name: "Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate}
          onChange={(e) => handleInputChange(row.local_id, e, "sale")}
        />
      ),
      width: "160px",
    },
    {
      name: "Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime}
          onChange={(e) => handleInputChange(row.local_id, e, "sale")}
        />
      ),
      width: "160px",
    },
  ];

  const serviceColumns = [
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.materialDescription}</p>
          <p className="m-0 text-muted">{row.materialCode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row.barcode}</p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row.orderedQuantity}</p>
          <p className="m-0 text-muted">{row.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "120px",
    },
    { name: "Net Value", selector: (row) => row.netValue, width: "120px" },
    { name: "Tax %", selector: (row) => row.taxPercentage, width: "100px" },
    { name: "Gross Value", selector: (row) => row.grossValue, width: "130px" },
    {
      name: "Status",
      cell: (row) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              row.status === "In Progress" ? "#ffc107" : "#28a745",
            color: "black",
            padding: "6px 10px",
            borderRadius: "10px",
          }}
        >
          {row.status}
        </span>
      ),
      width: "150px",
    },
    {
      name: "Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate}
          onChange={(e) => handleInputChangeService(row.local_id, e)}
        />
      ),
      width: "160px",
    },
    {
      name: "Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime}
          onChange={(e) => handleInputChangeService(row.local_id, e)}
        />
      ),
      width: "160px",
    },
  ];

  const accessoryColumns = [
    {
      name: "Accessory Product",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row?.materialDescription}</p>
          <p className="m-0 text-muted">{row?.materialCode}</p>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <div>
          <p className="fw-bold m-0">{row?.barcode || "Not Assigned"}</p>
        </div>
      ),
      width: "180px",
    },

    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.orderedQuantity}</p>
          <p className="m-0 text-muted">{row?.orderUnitOfMeasure}</p>
        </div>
      ),
      width: "120px",
    },
    {
      name: "Brand",
      cell: (row) => <span>{row?.brand || "--"}</span>,
      width: "120px",
    },
    {
      name: "Group",
      cell: (row) => (
        <span className="text-muted">{row?.materialGroup || "--"}</span>
      ),
      width: "180px",
    },
    {
      name: "Date",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="date"
          name="disPatchedDate"
          value={row.disPatchedDate || ""}
          onChange={(e) => {
            const { name, value } = e.target;
            setAccessoryItems((prev) =>
              prev.map((item) =>
                item.local_id === row.local_id
                  ? { ...item, [name]: value }
                  : item,
              ),
            );
          }}
        />
      ),
      width: "160px",
    },
    {
      name: "Time",
      cell: (row) => (
        <InputField
          className="inputBox"
          type="time"
          name="disPatchedTime"
          value={row.disPatchedTime || ""}
          onChange={(e) => {
            const { name, value } = e.target;
            setAccessoryItems((prev) =>
              prev.map((item) =>
                item.local_id === row.local_id
                  ? { ...item, [name]: value }
                  : item,
              ),
            );
          }}
        />
      ),
      width: "160px",
    },
  ];

  const assignmentHistoryColumns = [
    {
      name: "Action",
      cell: (row, index) => {
        const isLatest = index === 0; // data is reversed, so index 0 = latest
        const isPending = (row?.jobStatus || "Pending") === "Pending";
        const isCurrentUserAssigned =
          row?.serviceProviderUserId === userData?.data?.userId;

        // const canAct =
        //   isDispatchManager || (isServiceExecutive && isCurrentUserAssigned);

        // if (!canAct || !isLatest || !isPending) {
        //   return null;
        // }

        // return (
        //   <div className="d-flex gap-2" style={{ whiteSpace: "nowrap" }}>
        //     <button
        //       className="btn btn-success"
        //       style={{
        //         fontSize: "12px",
        //         padding: "4px 12px",
        //         borderRadius: "6px",
        //       }}
        //       onClick={() => {
        //         setJobStatusTarget("Done");
        //         setShowJobStatusModal(true);
        //       }}
        //     >
        //       Done
        //     </button>
        //     <button
        //       className="btn btn-danger"
        //       style={{
        //         fontSize: "12px",
        //         padding: "4px 12px",
        //         borderRadius: "6px",
        //       }}
        //       onClick={() => {
        //         setJobStatusTarget("Not Done");
        //         setShowJobStatusModal(true);
        //       }}
        //     >
        //       Not Done
        //     </button>
        //   </div>
        // );
        const canAct =
          isDispatchManager || (isServiceExecutive && isCurrentUserAssigned);

        if (!canAct || !isLatest || !isPending) {
          return null;
        }

        // "Done" requires dispatch to be saved first.
        // "Not Done" is for failed dispatches — no save required.
        const doneEnabled = isDispatched;
        const doneTooltip = doneEnabled
          ? "Mark job as Done"
          : "Save Dispatch Details first to mark the job as Done.";

        return (
          <div className="d-flex gap-2" style={{ whiteSpace: "nowrap" }}>
            <button
              className="btn btn-success"
              style={{
                fontSize: "12px",
                padding: "4px 12px",
                borderRadius: "6px",
                opacity: doneEnabled ? 1 : 0.5,
                cursor: doneEnabled ? "pointer" : "not-allowed",
              }}
              disabled={!doneEnabled}
              title={doneTooltip}
              onClick={() => {
                setJobStatusTarget("Done");
                setShowJobStatusModal(true);
              }}
            >
              Done
            </button>
            <button
              className="btn btn-danger"
              style={{
                fontSize: "12px",
                padding: "4px 12px",
                borderRadius: "6px",
              }}
              title="Mark job as Not Done"
              onClick={() => {
                setJobStatusTarget("Not Done");
                setShowJobStatusModal(true);
              }}
            >
              Not Done
            </button>
          </div>
        );
      },
      width: "220px",
    },
    {
      name: "Job Status",
      cell: (row) => {
        const status = row?.jobStatus || "Pending";
        const badgeColor =
          status === "Done"
            ? "#28a745"
            : status === "Not Done"
              ? "#dc3545"
              : "#ffc107";
        return (
          <span
            className="badge"
            style={{
              backgroundColor: badgeColor,
              color: status === "Pending" ? "black" : "white",
              padding: "6px 10px",
              borderRadius: "10px",
            }}
          >
            {status}
          </span>
        );
      },
      width: "130px",
    },
    {
      name: "Job Details",
      selector: (row) => row?.jobStatusRemarks || "--",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.jobStatusRemarks || "--"}</p>
          {/* <p className="m-0 text-muted">
            {formatDateWithAMPM(row?.jobStatusUpdatedAt) || ""}
          </p> */}
          <p className="m-0 text-muted">{row?.jobStatusUpdatedBy || ""}</p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Assigned Date",
      selector: (row) => row?.assignDateAndTime || "--",
      cell: (row) => {
        const { date, time } = formatIST(row?.assignDateAndTime);
        return (
          <div>
            <p className="m-0 fw-medium">{date}</p>
            <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
              {time}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Service Executive",
      selector: (row) => row?.serviceProviderName || "--",
      cell: (row) => (
        <div>
          <p className="m-0 fw-bold">{row?.serviceProviderName || "--"}</p>
          <p className="m-0 text-muted" style={{ fontSize: "11px" }}>
            {row?.serviceProviderCode || ""}
          </p>
        </div>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Category",
      selector: (row) => row?.serviceAssignCategory || "--",
      cell: (row) => (
        <span className="text-dark">{row?.serviceAssignCategory || "--"}</span>
      ),
      width: "150px",
    },
    {
      name: "Remark",
      selector: (row) => row?.serviceAssignCategoryDescription || "--",
      cell: (row) => <p>{row?.serviceAssignCategoryDescription || "--"}</p>,
      sortable: true,
      width: "200px",
    },
    {
      name: "Assigned By",
      selector: (row) => row?.assignedBy || "--",
      cell: (row) => (
        <span className="fw-medium">{row?.assignedBy || "--"}</span>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Collect Money",
      selector: (row) => row?.shouldCollectMoney,
      cell: (row) => (
        <span
          className={
            row?.shouldCollectMoney ? "text-success fw-bold" : "text-muted"
          }
        >
          {row?.shouldCollectMoney ? "Yes" : "No"}
        </span>
      ),
      width: "120px",
    },
  ];

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        centered
        backdrop="static"
        ref={ref}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Dispatch Creation - {erfData?.documentNumber}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/*  Header Level Dispatch Details Block */}
          <div className="accordion" id="accordionDispatchDetails">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isDispatchVisible
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                      }`}
                      onClick={() => toggleCardVisibility1(!isDispatchVisible)}
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">DD</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">Dispatch Details</span>
                    <span className="subHeaderTitle">
                      Vehicle/Truck, Driver & Address Information
                    </span>
                  </Col>
                  <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                    {/* buttons if needed */}
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isDispatchVisible ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row className="">
                    {/* Truck No */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-card-text me-1 text-primary"></i>Truck No <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Vehicle No"
                        name="truckNo"
                        placeholder="Enter Vehicle No"
                        value={dispatchHeader.truckNo}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>

                    {/* Driver Name */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-person me-1 text-primary"></i>Driver Name <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Driver name"
                        name="driverName"
                        placeholder="Enter Driver Name"
                        value={dispatchHeader.driverName}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>

                    {/* Contact Number */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-telephone me-1 text-primary"></i>Contact Number <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Contact Number"
                        name="contactNumber"
                        placeholder="Enter Contact Number"
                        value={dispatchHeader.contactNumber}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>

                    {/* Dispatch Vehicle */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-truck-front me-1 text-primary"></i>Dispatch Vehicle <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Dispatch Vehicle"
                        name="dispatchVehicle"
                        placeholder="Enter Vehicle Type"
                        value={dispatchHeader.dispatchVehicle}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>

                    {/* Pincode */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-pin-map me-1 text-primary"></i>Pincode <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Pincode"
                        name="addressPincode"
                        placeholder="Enter Pincode"
                        value={dispatchHeader.addressPincode}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>

                    {/* Dispatch Date */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-calendar3 me-1 text-primary"></i>Dispatch Date
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Dispatch Date"
                        type="date"
                        name="dispatchDate"
                        value={dispatchHeader.dispatchDate}
                        onChange={handleHeaderChange}
                      />
                    </Col>

                    {/* Dispatch Time */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-clock me-1 text-primary"></i>Dispatch Time
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Dispatch Time"
                        type="time"
                        name="dispatchTime"
                        value={dispatchHeader.dispatchTime}
                        onChange={handleHeaderChange}
                      />
                    </Col>

                    {/*  Dispatch Remark - label fix chesam */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-chat-left-text me-1 text-primary"></i>Dispatch Remark <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Dispatch Remark"
                        name="erfDispatchRemark"
                        placeholder="Enter Dispatch Remark"
                        value={dispatchHeader.erfDispatchRemark}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>
                    {/* Dispatch Address */}
                    <Col
                      lg={6}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      {/* <label className="form-label fw-semibold" style={{ fontSize: "13px", color: "#495057" }}>
              <i className="bi bi-geo-alt me-1 text-primary"></i>Dispatch Address <span className="text-danger">*</span>
            </label> */}
                      <InputField
                        className="inputBox"
                        label="Dispatch Address"
                        name="dispatchAddress"
                        placeholder="Enter Dispatch Address"
                        value={dispatchHeader.dispatchAddress}
                        onChange={handleHeaderChange}
                        required={true}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          {/* DataTable */}
          {/* <Row>
          <Col lg={12}>
            <DataTable columns={columns} data={rentItems} pagination />
          </Col>
        </Row> */}

          <div className="accordion mt-2" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                      }`}
                      onClick={toggleCardVisibility}
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">LS</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">Line Items List</span>
                    <span className="subHeaderTitle">
                      View of Line Items List and Status{" "}
                    </span>
                  </Col>

                  <Col
                    xs={12}
                    md={2}
                    lg={2}
                    className="headerButtonAlign"
                  ></Col>
                </Row>
              </h2>

              <div
                // id="acc"
                className={`accordion-collapse collapse show ${
                  isCardVisible ? "visible" : ""
                }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  {erfData?.rentItems?.length > 0 && (
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={rentItems}
                          pagination
                          paginationServer
                        />
                      </Col>
                    </Row>
                  )}
                  {erfData?.saleItems?.length > 0 && (
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={saleColumns}
                          data={saleItems}
                          pagination
                          paginationServer
                        />
                      </Col>
                    </Row>
                  )}
                  {erfData?.serviceItems?.length > 0 && (
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <p
                          className="fw-bold text-muted mt-2 mb-1"
                          style={{ fontSize: "13px" }}
                        >
                          Service Items
                        </p>
                        <DataTable
                          title=""
                          columns={serviceColumns}
                          data={serviceItems}
                          pagination
                          paginationServer
                        />
                      </Col>
                    </Row>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* ── NEW: Accessories Table ──────────────────────────────────────────────── */}
          {erfData?.accessoryItems?.length > 0 && (
            <div className="accordion mt-4" id="accordionAssignHistory">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isAccessoriesVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={() =>
                          toggleCardVisibility5(!isAccessoriesVisible)
                        }
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">AL</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Accessories List</span>
                      <span className="subHeaderTitle">
                        View of Line Accessories Items List and Status
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isAccessoriesVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body p-0">
                    <DataTable
                      title=""
                      columns={accessoryColumns}
                      data={accessoryItems}
                      pagination
                      noDataComponent={
                        <div className="p-3 text-center text-muted">
                          No accessories found
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {erfData?.documentNumber && (
            <ERFPaymentSection
              documentNumber={erfData?.documentNumber}
              allowAddCreditNote={false}
            />
          )}

          <ERFTravelSection
            travelHistory={travelHistory}
            erfStatusCode={erfData?.erfStatusCode ?? ""}
            onSave={handleTravelSave}
            onConfirmRow={handleTravelConfirmRow}
            onUnsavedRowsChange={setHasUnsavedTravel}
          />

          {/* Supporting Documents Section  */}
          <div className="accordion" id="accordionDispatchDetails">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isDispatchVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                      }`}
                      onClick={() => toggleCardVisibility2(!isDispatchVisible2)}
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">SD</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">
                      Dispatch/Service Supporting Documents
                    </span>
                    <span className="subHeaderTitle">
                      Supporting Documents Details & Information
                    </span>
                  </Col>
                  <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                    {/* buttons if needed */}
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isDispatchVisible2 ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row className="align-items-center ms-5">
                    {/*  File Upload */}
                    <Col xs={12} md={4} lg={4}>
                      <FileUploadComponentForHB
                        id="dispatchDocumentsUpload"
                        name="dispatchDocumentsUpload"
                        label="Attach Documents"
                        allowedTypes={[
                          "image/png",
                          "image/jpeg",
                          "application/pdf",
                        ]}
                        multiple={true}
                        // onSuccessUpload={(data, index) =>
                        //   onSuccessUploadDocumentType(data, index)
                        // }
                        onSuccessUpload={(data) =>
                          setDispatchHeader((prev) => ({
                            ...prev,
                            dispatchDocumentsUpload: data?.attachmentId || "",
                          }))
                        }
                        value={dispatchHeader?.dispatchDocumentsUpload || ""}
                        required={true}
                      />
                      {dispatchHeader?.dispatchDocumentsUpload && (
                        <img
                          src="assets/img/newIcons/attached-file.png"
                          className="attachmentIcon"
                          alt="attachment"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleViewFile(
                              dispatchHeader.dispatchDocumentsUpload,
                            )
                          }
                        />
                      )}
                    </Col>

                    {/*  Checkbox */}
                    <Col xs={12} md={3} lg={3}>
                      <Form.Check
                        type="checkbox"
                        label="Show Payment QR Image"
                        checked={showImage}
                        onChange={(e) => setShowImage(e.target.checked)}
                      />
                    </Col>

                    {/*  QR Image */}
                    <Col xs={12} md={3} lg={3}>
                      {showImage && (
                        <img
                          src="/assets/img/medirent/printoutimage/medirentpaymemtthroughqr.jpeg"
                          alt="QR"
                          style={{
                            width: "300px",
                            height: "auto",
                            borderRadius: "8px",
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          <div className="accordion" id="accordionDispatchDetails">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <Row className="accordion-button">
                  <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                    <i
                      className={`bi ${
                        isDispatchVisible
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                      }`}
                      onClick={() => toggleCardVisibility1(!isDispatchVisible)}
                    ></i>
                  </Col>
                  <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                    <span className="iconLogo">ED</span>
                  </Col>
                  <Col xs={12} md={8} lg={8}>
                    <span className="headerTitle">EwayBill Status Details</span>
                    <span className="subHeaderTitle">
                      EwayBill Status Details & Information
                    </span>
                  </Col>
                  <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                    {/* buttons if needed */}
                  </Col>
                </Row>
              </h2>

              <div
                className={`accordion-collapse collapse show ${
                  isDispatchVisible ? "visible" : ""
                }`}
              >
                <div className="accordion-body">
                  <Row className="">
                    {/* Truck No */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Eway Date "
                        name="ewayBillDate"
                        type="date"
                        // placeholder="Enter Eway Bill Date"
                        value={dispatchHeader.ewayBillDate}
                        onChange={handleHeaderChange}
                        // required={true}
                      />
                    </Col>

                    {/* Eway Bill Number Name */}
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Eway Bill No"
                        name="ewayBillNo"
                        placeholder="Enter EwayBill No"
                        value={dispatchHeader.ewayBillNo}
                        onChange={handleHeaderChange}
                        // required={true}
                      />
                    </Col>

                    <Col
                      xs={12}
                      md={4}
                      lg={4}
                      className="commTopButtonRightLeftPadding d-flex"
                    >
                      <FileUploadComponentForHB
                        id="ewayBillUpload"
                        name="ewayBillUpload"
                        label="Attach delivery challan"
                        allowedTypes={[
                          "image/png",
                          "image/jpeg",
                          "application/pdf",
                        ]}
                        multiple={false}
                        onSuccessUpload={(data, index) =>
                          onSuccessUploadDocumentType(data, index)
                        }
                        value={dispatchHeader?.ewayBillUpload || ""}
                        // disabled={disabled}
                      />
                      <div className="d-flex align-items-center pe-2">
                        {dispatchHeader?.ewayBillUpload ? (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(dispatchHeader?.ewayBillUpload)
                            }
                          />
                        ) : (
                          "--"
                        )}
                      </div>
                    </Col>
                    <Col
                      lg={3}
                      md={6}
                      className="commTopButtonRightLeftPadding"
                    >
                      <button
                        type="button"
                        className="btnTable"
                        onClick={handleOpenEwayForm}
                      >
                        SE Details Form
                      </button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          {/* <Row className="mt-2">
          <Col xs={12} md={6} lg={6} className="headerButtonAlign">
            {travelHistory.length === 0 && !hasUnsavedTravel && (
              <div className="alert alert-warning py-1 mb-2">
                At least one travel entry is required before dispatching. Please
                add and save a travel entry.
              </div>
            )}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={4} lg={4} className="headerButtonAlign">
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              <button className="btnTable btn-danger" onClick={onHide}>
                Cancel
              </button>
            </Col>
            <Col
              xs={4}
              md={2}
              lg={2}
              className="d-flex justify-content-between"
            >
              <button
                className="btnTable"
                onClick={handleUpdate}
                disabled={hasUnsavedTravel || travelHistory.length === 0}
              >
                Save
              </button>
            </Col>
          </Col>
        </Row> */}

          <Row className="mt-2">
            <Col xs={12}>
              {isDispatched ? (
                <>
                  <div
                    className="alert alert-success d-flex align-items-center py-2 mb-3"
                    style={{ fontSize: "13px", borderRadius: "8px" }}
                  >
                    <i
                      className="bi bi-check-circle-fill me-2"
                      style={{ fontSize: "16px" }}
                    ></i>
                    <div>
                      <strong>ERF Dispatched Successfully!</strong>
                      <span className="ms-2">
                        Please mark the job status before closing.
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {travelHistory.length === 0 && !hasUnsavedTravel && (
                    <div className="alert alert-warning py-1 mb-2">
                      At least one travel entry is required before dispatching.
                    </div>
                  )}
                  {hasUnsavedTravel && (
                    <div className="alert alert-warning py-1 mb-2">
                      Please save travel entries, before dispatching.
                    </div>
                  )}
                  <Row className="mt-4">
                    <Col xs={12} md={4} lg={4} className="headerButtonAlign">
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-between"
                      >
                        <button
                          className="btnTable btn-danger"
                          onClick={onHide}
                        >
                          Cancel
                        </button>
                      </Col>
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-between"
                      >
                        <button
                          className="btnTable"
                          onClick={handleUpdate}
                          disabled={
                            hasUnsavedTravel || travelHistory.length === 0
                          }
                        >
                          Save Dispatch Details
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
          {/* ── Assignment History ─────────────────────────────────── */}
          {erfData?.assignedServiceExecutives?.length > 0 && (
            <div className="accordion mt-4" id="accordionAssignHistory">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isServiceExecutiveHistoryVisible
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={() =>
                          toggleCardVisibility3(
                            !isServiceExecutiveHistoryVisible,
                          )
                        }
                      ></i>
                    </Col>
                    <Col xs={1} md={2} lg={2} className="text-center logoBtn">
                      <span className="iconLogo">AH</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">
                        Service Executive Assignment History
                      </span>
                      <span className="subHeaderTitle">
                        Previously assigned service executives
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isServiceExecutiveHistoryVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body p-0">
                    <DataTable
                      columns={assignmentHistoryColumns}
                      data={[...erfData.assignedServiceExecutives].reverse()} // latest first
                      pagination
                      // paginationRowsPerPageOptions={[5, 10, 20]}
                      noDataComponent={
                        <div className="p-3 text-muted text-center">
                          No assignment history found
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <FileViewerModalForHB
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
          showDelete={erfData?.erfStatusCode === "USE"}
          onDeleteSuccess={(result) => {
            if (!result.hasFiles) {
              setDispatchHeader((prev) => ({
                ...prev,
                dispatchDocumentsUpload: "",
              }));
            }
          }}
        />

        {/* <EwayBillModal
        show={showEwayForm}
        onHide={handleCloseEwayForm}
        erfData={erfData}
        ewayData={ewayData}
        setEwayData={setEwayData}
      /> */}
        <EwayBillModal
          show={showEwayForm}
          onHide={handleCloseEwayForm}
          erfData={erfData}
          ewayData={ewayData}
          setEwayData={setEwayData}
        />
      </Modal>
      {/* Job Status Remarks Modal */}
      <Modal
        show={showJobStatusModal}
        onHide={() => setShowJobStatusModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {jobStatusTarget === "Done"
              ? "Mark Job as Done"
              : "Mark Job as Not Done"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label fw-bold">
            Remarks <span className="text-danger">*</span>
          </label>
          <textarea
            className="form-control"
            rows={3}
            value={jobStatusRemarks}
            onChange={(e) => setJobStatusRemarks(e.target.value)}
            placeholder={
              jobStatusTarget === "Done"
                ? "Enter completion remarks..."
                : "Enter reason why job is not done..."
            }
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btnTable btn-danger"
            onClick={() => {
              setShowJobStatusModal(false);
              setJobStatusRemarks("");
            }}
          >
            Cancel
          </button>
          <button
            className="btnTable"
            // onClick={async () => {
            //   await handleMarkJobStatus(jobStatusTarget, jobStatusRemarks);
            //   setShowJobStatusModal(false);
            //   setJobStatusRemarks("");
            // }}
            onClick={() =>
              handleMarkJobStatus(jobStatusTarget, jobStatusRemarks)
            }
          >
            Submit
          </button>
        </Modal.Footer>
      </Modal>
      <FailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        failuremodaldata={failureModalData}
        requiredfields={errorFields}
      />
    </>
  );
});

export default DispatchModal;
